<template lang="pug">
    Modal(v-model="isModalShow" :title="originPolicyName" width="640")
        Spin(v-if="loading" fix)
        div(v-else-if="originsOptions.length > 0")
            Table(
                :columns="columns"
                :data="originsOptions"
                size="small"
                border
            )
        Alert(v-else type="warning" show-icon) No Data
        div(slot="footer")
            Button(@click="isModalShow = false") {{ $t('global.close') }}
</template>

<script>
import { getEsData } from "@/api/esdata";
import { boolToIcons, boolToColors } from "@/libs/rcmTableFieldsFunction";

export default {
    name: "OriginPolicyOriginsModal",
    props: {
        searchView: { type: String, default: "" }
    },
    data() {
        return {
            isModalShow: false,
            loading: false,
            originsOptions: [],
            groupName: "",
            originPolicyName: ""
        };
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t("originPolicy.host"),
                    key: "host",
                    minWidth: 200,
                    render: (h, params) => h("span", params.row.host)
                },
                {
                    title: this.$t("originPolicy.isHostEnabled"),
                    key: "isHostEnabled",
                    minWidth: 120,
                    align: "center",
                    render: (h, params) =>
                        h("Icon", {
                            props: {
                                type: boolToIcons({
                                    value: params.row.isHostEnabled,
                                    falseToDash: false
                                }),
                                color: boolToColors({
                                    value: params.row.isHostEnabled,
                                    falseToGrey: false
                                }),
                                size: 24
                            }
                        })
                },
                {
                    title: this.$t("originPolicy.weight"),
                    key: "weight",
                    width: 100,
                    align: "center",
                    render: (h, params) => h("span", params.row.weight)
                },
                {
                    title: this.$t("originPolicy.isBackupHost"),
                    key: "isBackupHost",
                    width: 120,
                    align: "center",
                    render: (h, params) =>
                        h("Icon", {
                            props: {
                                type: boolToIcons({
                                    value: params.row.isBackupHost,
                                    falseToDash: false
                                }),
                                color: boolToColors({
                                    value: params.row.isBackupHost,
                                    falseToGrey: false
                                }),
                                size: 24
                            }
                        })
                }
            ];
        }
    },
    methods: {
        open(groupName, originPolicyName) {
            this.groupName = groupName;
            this.originPolicyName = originPolicyName;
            this.isModalShow = true;
            this.fetchData();
        },
        async fetchData() {
            this.loading = true;
            this.originsOptions = [];

            try {
                const result = await getEsData({
                    isFuzzySearch: false,
                    esIndex: "rcm-originpolicies",
                    from: 0,
                    size: 1,
                    filters: [
                        { key: "groupName", type: "string", value: this.groupName },
                        { key: "originPolicyName", type: "string", value: this.originPolicyName }
                    ],
                    // 只拿取必要欄位的資料, origins於後端邏輯為必要欄位
                    _source: [
                        "originsOptions.host",
                        "originsOptions.isHostEnabled",
                        "originsOptions.weight",
                        "originsOptions.isBackupHost",
                        "origins"
                    ],
                    searchView: this.searchView,
                    sort: [{ modifiedDate: { order: "desc" } }]
                });

                const list = result.data.success ? result.data.mapData : [];
                this.originsOptions = list[0].originsOptions;
            } catch (error) {
                console.log(error);
                this.originsOptions = [];
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/OriginPolicyOriginsModal.vue